<app-navbar></app-navbar>

<section class="blog-area ptb-100">
  <div class="container">
    <h3 class="widget-title" style="color: #ffffff; text-align: center">
      A Visit at Chattogram Zoo
    </h3>
    <hr />
    <div>
      <p style="color: white;">
        Amidst in nature. <br />
        A troupe of pupils of Autism pre-primary, Autism junior level, Autism
        middle level, Vision Impaired, and Physically challenged sections of
        Proyash-Chattogram, visited the nature and animals in Chattogram Zoo.
      </p>
      <section class="blog-area gallery-section">
        <div class="container">
          <div class="container">
            <div class="gallery-container">
              <div class="gallery">
                <a
                  *ngFor="let image of images"
                  class="gallery__item"
                  href="{{ image.src }}"
                  [title]="image.alt"
                >
                  <img
                    [src]="image.thumbnail"
                    [alt]="image.alt"
                    class="popup-btn"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</section>
